import React, { useState, useContext, useEffect } from 'react'
import './wallet.css'
import {
    handleRedirectInternal,
    mapData,
    jsonToFormData,
    currencyFormat,
} from '../../Product/common/components'
import { Link, useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../Product/context/auth/authContext'
import AlertContext from '../../Product/context/alert/alertContext'
import ProductContext from '../../Product/context/product/productContext'
import PluginContext from '../../Product/context/plugin/pluginContext'
import NoRecordsFound from '../../Product/components/atoms/NoRecordsFound'
import Loader from '../../assets/loader'
import moment from 'moment'
import { setRef } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'
import Copy from '../../utils/CommonFunctionality/Share/Copy'

const ExtendedPickupHistory = () => {
    const authContext = useContext(AuthContext)
    const productContext = useContext(ProductContext)
    const pluginContext = useContext(PluginContext)
    const validationArray = Yup.object({})
    const [regBtnLoading, setRegBtnLoading] = useState(false)
    const [listLoading, setListLoading] = useState(false)
    const [referralist, setReferralList] = useState([])
    const [referralListCount, setReferralListCount] = useState(0)
    const [page, setPage] = useState(1)
    const history = useHistory()
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const { user, loadUser, isAuthenticated, active_plugins, getActivePlugins } = authContext
    const { getReferralHistory, responseStatus, all_referrals, clearResponse } = pluginContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext

    useEffect(() => {
        if (responseStatus && responseStatus !== '') {
            if (responseStatus.from === 'getReferralHistory') {
                // redeemEnablelist({
                //     site_id: global?.storeDetails?.site_id,
                //     user_id: user.id,
                // })
                setListLoading(false)
            }
        }
    }, [responseStatus])
    useEffect(() => {
        console.log('all_referrals-----', all_referrals)
        if (all_referrals?.message && all_referrals?.message?.results.length > 0) {
            console.log('ref ----', all_referrals?.message?.result)
            setReferralList(all_referrals?.message?.results)
            setReferralListCount(all_referrals?.message?.results_cnt)
            setListLoading(false)
        } else {
            setReferralList([])
            setReferralListCount(0)
            setListLoading(false)
            setRegBtnLoading(false)
        }
    }, [all_referrals])
    useEffect(() => {
        setListLoading(true)
        const fetchReferralList = async () => {
            if (user) {
                const res = await getReferralHistory({
                    site_id: global?.storeDetails?.site_id,
                    user_id: user.id,
                    invoice_id: '',
                    type: 'extended_pickup_added',
                    page: page,
                    perlimit: 10,
                })
            }
        }
        fetchReferralList()
    }, [user, page])

    return (
        <div>
            {listLoading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : referralist.length > 0 ? (
                <>
                    {/* <div>
                        Current Balance :{' '}
                        {currencyFormat(user?.wallet_amount > 0 ? user.wallet_amount : 0)}
                    </div> */}
                    <div className="table-responsive mt-4">
                        <table className="table table-hover mobile-table responisveTable extendedPickupTable hidden-mobile">
                            <thead>
                                <tr>
                                    <th role="Status">Invoice ID</th>
                                    <th role="Status">Extended Date</th>
                                    <th role="Amount">Amount</th>
                                    <th role="Status">Date of Payment</th>
                                    <th role="Amount">Description</th>
                                </tr>
                            </thead>

                            <tbody>
                                {referralist.length !== 0 &&
                                    referralist.map((item, index) => {
                                        return (
                                            <>
                                                {item ? (
                                                    <tr key={index}>
                                                        <td
                                                            data-label={
                                                                isVarifiedGfTheme
                                                                    ? 'Invoice'
                                                                    : 'extendedInvoice'
                                                            }
                                                            className="center navLinkColor"
                                                            onClick={() => {
                                                                handleRedirectInternal(
                                                                    history,
                                                                    item.win == 0
                                                                        ? `invoice/buynow?id=${item.invoice_id}`
                                                                        : `invoice/auction?id=${item.invoice_id}`,
                                                                )
                                                            }}
                                                        >
                                                            {item?.invoice_id}
                                                        </td>
                                                        <td
                                                            data-label={
                                                                isVarifiedGfTheme
                                                                    ? 'Extended Date'
                                                                    : 'redeem-date'
                                                            }
                                                            className="center"
                                                        >
                                                            {moment
                                                                .utc(item?.extended_date)
                                                                .local()
                                                                .format('dddd, MMMM DD, YYYY')}
                                                        </td>
                                                        <td data-label="amount" className="center">
                                                            <span>
                                                                {currencyFormat(item?.amount)}
                                                            </span>
                                                        </td>
                                                        <td
                                                            data-label={
                                                                isVarifiedGfTheme
                                                                    ? 'Date of Payment'
                                                                    : 'redeem-date'
                                                            }
                                                            className="center"
                                                        >
                                                            {moment
                                                                .utc(
                                                                    item?.date_add,
                                                                    'MM/DD/YYYY hh:mm:ss A',
                                                                )
                                                                .local()
                                                                .format('dddd, MMMM DD, YYYY')}
                                                        </td>
                                                        <td
                                                            data-label="description"
                                                            className="center"
                                                        >
                                                            {`Added to Invoice ${item?.invoice_id}`}
                                                        </td>
                                                    </tr>
                                                ) : null}
                                            </>
                                        )
                                    })}
                            </tbody>
                        </table>
                        {!isVarifiedGfTheme && (
                            <div className="extendedPickupTable hidden-desktop">
                                {referralist.length !== 0 &&
                                    referralist.map((item, index) => {
                                        return (
                                            <>
                                                {item ? (
                                                    <div key={index} className="extendedCard">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p>Invoice ID</p>
                                                            <p
                                                                className="invoiceId"
                                                                onClick={() => {
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        item.win == 0
                                                                            ? `invoice/buynow?id=${item.invoice_id}`
                                                                            : `invoice/auction?id=${item.invoice_id}`,
                                                                    )
                                                                }}
                                                            >
                                                                {item?.invoice_id}
                                                            </p>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p>Extended Date</p>
                                                            <p>
                                                                {moment
                                                                    .utc(item?.extended_date)
                                                                    .local()
                                                                    .format('dddd, MMMM DD, YYYY')}
                                                            </p>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p>Amount</p>
                                                            <p>
                                                                <span>
                                                                    {currencyFormat(item?.amount)}
                                                                </span>
                                                            </p>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p>Date of Payment</p>
                                                            <p>
                                                                {' '}
                                                                {moment
                                                                    .utc(
                                                                        item?.date_add,
                                                                        'MM/DD/YYYY hh:mm:ss A',
                                                                    )
                                                                    .local()
                                                                    .format('dddd, MMMM DD, YYYY')}
                                                            </p>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p>Description</p>
                                                            <p>
                                                                {' '}
                                                                {`Added to Invoice ${item?.invoice_id}`}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </>
                                        )
                                    })}
                            </div>
                        )}
                    </div>
                    <Pagination
                        count={Math.ceil(referralListCount / 10)}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                    />
                </>
            ) : (
                <NoRecordsFound />
            )}
        </div>
    )
}

export default ExtendedPickupHistory
